import { LuSearch } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "exportProductDEPBProductgroupMain",
            label: "Product Group",
            component: "dropdown",
            width: "30%",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            options: [
              { label: "Engineering Products", value: "Engineering Products" },
              { label: "Chemicals and allied", value: "Chemicals and allied" },
              { label: "Plastics", value: "Plastics" },
              { label: "Leather and Leather", value: "Leather and Leather" },
              { label: "Sports Goods", value: "Sports Goods" },
            ],
          },
          {
            name: "exportProductRateListMain",
            label: "Rate List Sr.No",
            component: "text-field",
            icon: LuSearch,
            width: "30%",
            type: "autocomplete",
            endpoint: "getRateListMaster",
          },
          {
            name: "exportProductStdIONormsMain",
            label: "Std. I/O Norms",
            component: "text-field",
            width: "30%",
          },
        ],
        row2: [
          {
            name: "exportProductDEPBRateMain",
            label: "DEPB Rate",
            component: "text-field",
            width: "15%",
            placeholder: "0.00",
            // actionText: "%",
            dataType: "int",
          },

          {
            name: "exportProductDEPBQtyMain",
            label: "DEPB Qty",
            component: "text-field",
            width: "16%",
            placeholder: "15.000",
            // actionText: "/",
            styles: {
              pl: 2,
            },
            dataType: "int",
          },
          {
            name: "exportProductDEPBUnitMain",
            // label: "Rate List Sr.No",
            component: "text-field",
            icon: LuSearch,
            placeholder: "NOS",
            width: "10%",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
          {
            name: "exportProductCapValueMain",
            label: "CAP Value",
            component: "text-field",
            width : "20%",
            // placeholder: "15.000"
          },
        ],
      },
    },
  ],
};
